export default "__VITE_ASSET__C8LeV2AX__"